import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import {NavLink} from "react-router-dom";
import './Footer.scss';
import {isInternalLink} from "../../helpers/filters";
import {trackEventByUrl} from "../../helpers/events";

const Footer = ({legalLinks}) => (
    <React.Fragment>
        <footer className="site-footer">
            <div className="container">
                <p className="copyright">&copy; {moment().format('YYYY')} MarketAxess Holdings Inc.</p>

                {legalLinks.length ? (
                    <ul>
                        {legalLinks.filter(link => link.url.path).map(link => (
                            <li key={`${link.url.path}_${link.label}`} className="legalFooterItem">
                                {isInternalLink(link.url.path) && link.url.path !== '/website-issue' ? (
                                    <NavLink to={link.url.path}>{link.label}</NavLink>
                                ) : (
                                    <a onClick={() => trackEventByUrl(link.url.path, link.label)}
                                       href={link.url.path}>{link.label}</a>
                                )}
                            </li>
                        ))}
                    </ul>
                ) : null}


            </div>
            <div className="security-container">
                <div className="security-container-inner">
                <p>Please beware of malicious websites and applications impersonating MarketAxess: MarketAxess does not service retail customers, nor does it request or receive online money transfers. Always verify official channels, MarketAxess takes no responsibility for such third-party actions.</p>
                </div>
            </div>

        </footer>
    </React.Fragment>
);

Footer.propTypes = {
    // eslint-disable-next-line react/forbid-prop-types
    legalLinks: PropTypes.array
};

Footer.defaultProps = {
    links: [],
    legalLinks: []
};

export default Footer;



// WEBPACK FOOTER //
// ./frontend/components/Footer/Footer.jsx